/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsAccounts = {
  init: function($section){

    jQuery('.js-recover-password').on('click', function(){
      jQuery('#login').hide();
      jQuery('#recover-password').show();
    });

    jQuery('.cancel-recover-password').on('click', function(){
      jQuery('#recover-password').hide();
      jQuery('#login').show();
    })

  },

  unload: function($section) {
    jQuery('.js-recover-password').off();
    jQuery('.cancel-recover-password').off();
  }
}

/******/ })()
;